export default {
  pageTitle: 'Job Description',
  allLocation: 'ALL LOCATION(S)',
  foldLocation: 'FOLD LOCATION(S)',
  expand: 'Expand',
  collapse: 'Collapse',
  searchJobs: 'Search Jobs',
  msg: {
    openInBrowser: 'Please open in your browser',
    downloadMessenger: 'Please download messenger',
    downloadwhatsapp: 'Please download whatsapp',
    copyUrl: 'Please copy the address below'
  },
  disagree: 'Disagree',
  andContinue: 'and continue',
  agree: 'Agree',
  iAgree: 'I Agree',
  viewJobs: 'View Jobs',
  jobDetailSalary: 'SALARY',
  jobDetailRoleType: 'ROLE TYPE',
  fullTime: 'Full Time',
  partTime: 'Part Time',
  intern: 'Intern',
  jobDetailExperience: 'EXPERIENCE',
  notSpecified: 'Not Specified',
  years: 'year(s)',
  jobDetailWorkTime: 'WORK TIME',
  updateTime: 'Update Time',
  jobLocation: 'Location(s)',
  closePreview: 'Close Preview',
  changeDevice: 'Change Device',
  jobDescription: 'Job Description',
  henkel: {
    iAgreeHnkel: 'I certify that I have read and agree to Henkel',
    declarationOfConsentPersonalData: 'Declaration of Consent - Personal Data',
    declarationOfConsentApplicationStatus: 'Declaration of Consent - Application Status',
    pleaseCheckHenkelTerms: 'Please Check Henkel Terms'
  },
  commonTosCheck: {
    iAcknowledgeIHaveReadAndAgreeTo: 'I acknowledge I have read and agree to',
    iCertifyThatIHaveReadAndAgreeToNestlePolicy: 'I certify that I have read and agree to Nestle policy',
    iCertifyThatIHaveReadAndAgreeTo: 'I certify that I have read and agree to',
    pleaseAgreeToTheTermsToContinue: 'Please agree to the terms to continue.',
    amsReadAndAgree: 'I have read, understand and consent to the'
  },
  fordApplyJobTipMsg: '*You may only apply to ONE (1) graduate position at Ford. Select carefully! All applications MUST be submitted in ENGLISH.',
  fordApplyJobTipMsg1: 'You may only apply to  ONE (1)  graduate position at Ford. Please make sure this job is your FIRST preference. After you click APPLY to this position, you CANNOT apply to any other graduate position at Ford.',
  fordApplyJobTipMsg2: 'All applications MUST be in  ENGLISH  language only. Chinese language applications will NOT be reviewed.',
  reapply: 'Reapply',
  applied: 'Applied',
  continueFinishApply: 'Continue',
  apply: 'Apply',
  refer: 'Refer',
  welcomeToRecommend: 'Welcome to Recommend',
  referralRewards: 'Referral Rewards',
  uponSuccessfulReferral: 'Upon successful referral',
  referralBonusesDesc: 'As for the bonus payment mechanism upon the successful referral, please refer to the Referral Policy of the specific hiring company.',
  referralBonus: 'Referral Bonus',
  next: 'NEXT',
  yes: 'YES',
  no: 'NO',
  areYouAnEmployee: 'Are you an employee of {company}?',
  submit: 'SUBMIT',
  yourReferral: 'your referral',
  toHR: 'to HR',
  or: 'OR',
  share: 'SHARE',
  toAFriend: 'to a friend',
  importantNotice: 'IMPORTANT NOTICE!',
  viewFullJobList: 'View Full Job List',
  viewOtherJobs: 'View other jobs',
  shareYourPersonally: 'Share this position with your friends for a chance to earn rewards.',
  shareYourPersonallyParm: 'Share this position with your friends for a chance to earn up to {balance} !!!',
  sendTo: 'Send to:',
  learnMore: 'Learn More',
  shareToWechat: 'Share To Wechat',
  holdToHighlight: 'Tap + hold to highlight content below',
  selectCopy: 'Select "copy"',
  openWeChatAndPaste: 'Open WeChat and paste',
  clickHereForMoreInformation: 'Click here for more information:',
  referTalentsForRewards: 'Refer Talents for Rewards',
  forFirstPeopleCountApplications: '(For first {peopleCount} referred applications)',
  accordingToEmployee: '(According to employee referral program policy)',
  hereIsAJob: 'Hi - Here is a job I thought you might be interested in:',
  referforRewards: 'Refer for Rewards!',
  upToRMBParm: 'Up to {balance} referral rewards available!!!',
  shareJobPoster: 'Share Job Poster',
  tapToShare: 'Tap to share:',
  saveVideo: 'Refer friends to apply through your personal QR code within the video!',
  videoIsGenerating: 'Video is generating',
  StarbucksInternalJobMsg: 'Oops! It seems you are not currently registered as a Starbucks Partner. You may have accidentally been sent an “employee only” role.',
  otherInternalJobMsg: 'Oops! It seems you are not currently registered as an Employee. You may have accidentally been sent an “employee only” role.',
  ADPReferralTipMessage: 'According to ADP WeChat Referral Policy',
  moreInfo: 'More info:',
  clickHereToApply: 'Click <a href="/logout/?backurl=/referral/employee-register/?company_id={companyId}" target="_blank">HERE</a> if you are already an Employee and would like to apply.',
  clickHereToApplyStarbucks: 'Click <a href="/logout/?backurl=/referral/employee-register/?company_id={ companyId }" target="_blank">HERE</a> if you are already an Partner and would like to apply.',
  jobClosed: 'Job Closed',
  jobClosedDescription: 'Thank you for your interest in <b>{companyName}</b>. Unfortunately the application deadline has now passed so you can not apply for this position. If you would like to be considered for other opportunities in the future, please click <b>“View Company”</b>.',
  viewCompany: 'View Company',
  moreCity: '{city1}, {city2}...',
  moreDistinct: '{distinct1}, {distinct2}...',
  moreAddress: '...',
  loading: 'Loading…',
  gotIt: 'Got it!',
  downloadNow: 'Click the button below to download',
  longPressToSave: 'Long press to save pictures to share with friends!',
  sharePoster: 'Share',
  btn: {
    referJobForRewards: 'Refer this job for rewards!',
    customReferralJobRewards: 'Refer this job for rewards!'
  },
  label: {
    step: {
      apply: 'Application Rewards',
      interview: 'Interview Rewards',
      onboard: 'Onboard Rewards',
      probation: 'Pass Probation Rewards'
    },
    referrerReward: {
      points: 'Reward {reward} Points',
      cash: 'Reward RMB {reward}',
      payroll: 'Reward RMB {reward}'
    },
    reward: {
      points: '{reward} Points',
      cash: 'RMB {reward}',
      payroll: 'RMB {reward}'
    },
    topReferrer: 'For first {count} referrer',
    finalReward: 'Final reward may vary based on actual hiring'
  },
  message: {
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failure. Please try to long tap to copy again'
  },
  rewardsClick: 'Check detail referral policy here'
}
